import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { StorageNodeBrowserComponent } from '../storage-node-browser/storage-node-browser.component'
import { ElderShellSlotDirective, DataViewIframeAdapterDirective } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-storage-node-browser-iframe',
  templateUrl: './storage-node-browser-iframe.component.html',
  styleUrls: ['./storage-node-browser-iframe.component.scss'],
  imports: [ElderShellSlotDirective, StorageNodeBrowserComponent, DataViewIframeAdapterDirective],
})
export class StorageNodeBrowserIframeComponent {
  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  constructor() {}
}
